import React from 'react';
import MerchantAccountColumn from "../../shared/component/dataTable/columns/MerchantAccountColumn.json";
import {Button} from 'reactstrap';
import Translate from "../../shared/language/Translate";
import DataTablePaginationWithButton from "../../shared/component/dataTable/DataTablePaginationWithButton";
import '../../shared/styles/SettingsPage.css';

export default class MerchantAccountList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selected: {},
            accountList:[]
        };
    }

    componentDidMount() {
        this.refreshDataTable();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <div className="settings-page__shell">
                    <div className="settings-page__header">
                        <h1 className="settings-page__title">Merchant Accounts</h1>
                    </div>
                    <div className="settings-page__panel">
                        <div className="settings-page__toolbar settings-page__toolbar--start">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--add"
                                onClick={() => {
                                    window.location.href = "#merchantAccountSave?";
                                }}>
                                <i className="pi pi-plus" aria-hidden="true"/>
                                <Translate contentKey="entity.action.add">Add</Translate>
                            </Button>
                        </div>
                        <div className="settings-page__table-wrap">
                            <DataTablePaginationWithButton
                                ref={(elem) => this.refDataTable = elem}
                                fields={MerchantAccountColumn.fields}
                                objectName={MerchantAccountColumn.name}
                                dataURL="crm/merchant/account/all"
                                view={this.view}
                                rows={10}
                                user={this.user}
                                selectionMode="single"
                                loading={this.state.loading}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    user = (data) => {
        localStorage.setItem("merchantAccountId", data.id);
        window.location.href = "#merchantUserSave?" + data.id;
    }

    view = (data) => {
        window.location.href = "#merchantAccountSave?" + data.id;
    }

    refresh = () => {
        this.refreshDataTable();
    }

    refreshDataTable = () => {
        this.refDataTable.refresh();
    }
}
